import { render, staticRenderFns } from "./UserSignup.vue?vue&type=template&id=05c148f9&scoped=true&"
import script from "./UserSignup.vue?vue&type=script&lang=js&"
export * from "./UserSignup.vue?vue&type=script&lang=js&"
import style0 from "./UserSignup.vue?vue&type=style&index=0&id=05c148f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c148f9",
  null
  
)

export default component.exports